/**
 * GIIN (Global Intermediary Identification Number) format: XXXXXX.XXXXX.XX.XXX
 * Total: 19 characters including dots (6 + 5 + 2 + 3 = 16 alphanumeric + 3 dots)
 * Note: Letter 'O' is not allowed in GIIN to avoid confusion with zero.
 */

export const GIIN_SEGMENT_LENGTHS = [6, 5, 2, 3] as const;

export const GIIN_PLACEHOLDERS = ["XXXXXX", "XXXXX", "XX", "XXX"] as const;

export const GIIN_SEGMENT_LABELS = [
  "GIIN segment 1 of 4",
  "GIIN segment 2 of 4",
  "GIIN segment 3 of 4",
  "GIIN segment 4 of 4",
] as const;

export const GIIN_SEGMENT_WIDTHS = ["76px", "68px", "44px", "52px"] as const;
